import type { LandingAlign } from '../../../../shared/types/people-landing';

/**
 * Clases compartidas del look "página web" del People Landing (Fase 1, 09/2026).
 * Un solo lugar para la tipografía y los detalles que repiten los bloques.
 */

/** Título de bloque/hero: Judson (--font-display) SIEMPRE en 400, nunca bold. */
export const DISPLAY_TITLE = 'font-display font-normal tracking-tight';

/** Eyebrow: label chico arriba de un título. Inter 11px bold, tracking 0.08em, verde marca. */
export const EYEBROW = 'text-[11px] font-bold uppercase tracking-[0.08em] text-brand-green';

/** Card con hover: se eleva, borde verde y sombra verde suave. */
export const CARD_HOVER =
  'rounded-2xl border border-border bg-card transition-all duration-300 hover:-translate-y-0.5 hover:border-brand-green hover:shadow-[0_8px_30px_rgba(28,201,185,0.12)]';

/** Clases de alineación (Fase 2.3): texto + ítems flex + botones acompañan. */
export const ALIGN_TEXT: Record<LandingAlign, string> = { left: 'text-left', center: 'text-center', right: 'text-right' };
export const ALIGN_ITEMS: Record<LandingAlign, string> = { left: 'items-start', center: 'items-center', right: 'items-end' };
export const ALIGN_JUSTIFY: Record<LandingAlign, string> = { left: 'justify-start', center: 'justify-center', right: 'justify-end' };
